import { render } from "./AuthLayout.vue?vue&type=template&id=591fa637&scoped=true&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=591fa637&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591fa637"]])

export default __exports__